import { axiosInstance } from ".."

const partnersComissionWithdrawalList = async (partnerId,querry) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/Commission/withdrawalRequest?partnerId=${partnerId}&${querry}`).then((res) => { 
            console.log(res)
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default partnersComissionWithdrawalList;